import { makeService } from './api';

const service = makeService('profiles');

export default service;